import React from 'react';
import { Container, Typography } from '@mui/material';

import style from './style';
import LazyImage from '../../Layouts/LazyImage';

const Details = () => {
  const classes = style();

  return (
    <section className={classes.section}>
      <Container>
        <div className={classes.companyDetails}>
          <div>
            <Typography variant="h5" paragraph>
              For collaborations
            </Typography>
            <div>
              <Typography variant="body1" component="div">
                <span>
                  <LazyImage src="/images/icons/mail.svg" alt="" />
                </span>
                <a href="mailto:mishu@novatr.com">mishu@novatr.com</a>
              </Typography>
            </div>
          </div>
          <div>
            <Typography variant="h5">For course queries</Typography>
            <div>
              <Typography variant="body1" component="div">
                <span>
                  <LazyImage src="/images/icons/mail.svg" alt="" />
                </span>
                <a href="mailto:support@novatr.com">support@novatr.com</a>
              </Typography>

              <Typography variant="body1" component="div">
                <span>
                  <LazyImage src="/images/icons/phone.svg" alt="" />
                </span>
                +91 9315788823
              </Typography>
            </div>
          </div>
          {/* <div>
            <Typography variant="h5" paragraph>
              Come meet us at
            </Typography>
            <div>
              <Typography variant="body1">
                4th Floor, Wework,
                <br />
                Platina Tower,
                <br />
                Sikanderpur,
                <br />
                Gurugram 122002
              </Typography>
            </div>
          </div> */}
        </div>

        <div className={classes.socialContainer}>
          <div>
            <a
              href="https://www.facebook.com/oneistox/"
              target="_blank"
              rel="noreferrer"
              title="Oneistox facebook"
            >
              <LazyImage src="/images/icons/social/facebook.svg" alt="" />
            </a>
            <a
              href="https://www.instagram.com/oneistox/"
              target="_blank"
              rel="noreferrer"
              title="Oneistox Instagram"
            >
              <LazyImage src="/images/icons/social/instagram.svg" alt="" />
            </a>
            <a
              href="https://www.linkedin.com/company/oneistox/"
              target="_blank"
              rel="noreferrer"
              title="Oneistox Linkedin"
            >
              <LazyImage src="/images/icons/social/linkedin.svg" alt="" />
            </a>

            <a
              href="https://www.youtube.com/channel/UC43uuiLYbswvwqgaSdepBpg"
              target="_blank"
              rel="noreferrer"
              title="Oneistox Youtube"
            >
              <LazyImage src="/images/icons/social/youtube.svg" alt="" />
            </a>
          </div>
          <Typography variant="body1" align="center">
            Follow us to stay updated.
          </Typography>
        </div>
      </Container>
    </section>
  );
};
export default Details;
